import React, { ReactNode } from 'react'

import { ComplaintsSelect } from '../components/ComplaintsSelect'
import { SymptomsSelect } from '../components/SymptomsSelect'
import { MedicationsSelect } from '../components/MedicationsSelect'
import { DiagnosticHypothesesSelect } from '../components/DiagnosticHypothesesSelect'
import { OtherSymptomsImpactOnWorkLife } from '../components/OtherSymptomsImpactOnWorkLife'
import { SuicidalIdeation } from '../components/SuicidalIdeation'
import { PsychiatristTreatment } from '../components/PsychiatristTreatment'
import { PatientGoal } from '../components/PatientGoal'
import { PatientConsumption } from '../components/PatientConsumption'
import { MedicalProfessionalReferral } from '../components/MedicalProfessionalReferral'
import { PatientCaseDescription } from '../components/PatientCaseDescription'
import { PatientCaseComplexity } from '../components/PatientCaseComplexity'
import { PatientNeedsToContinueTreatment } from '../components/PatientNeedsToContinueTreatment'
import { DocumentUpload } from '../components/DocumentUpload'
import { MedicalRecordFormType } from 'models/MedicalRecord/MedicalRecordForm.type'

interface Form {
  id: MedicalRecordFormType
  fields: ReactNode[]
}

export type TypeForm = {
  id: MedicalRecordFormType
  label: string
}

const { TECHNICAL_EVALUATION, EVOLUTION, OUTCOME } = MedicalRecordFormType

export const initialTypeFormOptions: TypeForm[] = [
  { id: TECHNICAL_EVALUATION, label: 'Avaliação técnica  🔍' },
  { id: EVOLUTION, label: 'Evolução  📊' },
  { id: OUTCOME, label: 'Desfecho  ⭐️' },
]

export const TECHNICAL_EVALUATION_FORM: Form = {
  id: TECHNICAL_EVALUATION,
  fields: [
    <ComplaintsSelect />,
    <SymptomsSelect />,
    <OtherSymptomsImpactOnWorkLife />,
    <SuicidalIdeation />,
    <PatientConsumption />,
    <MedicationsSelect />,
    <PsychiatristTreatment />,
    <PatientGoal />,
    <PatientCaseComplexity />,
    <PatientCaseDescription />,
    <DiagnosticHypothesesSelect />,
    <MedicalProfessionalReferral />,
    <DocumentUpload />,
  ],
}

export const EVOLUTION_FORM: Form = {
  id: EVOLUTION,
  fields: [
    <PatientCaseDescription />,
    <PatientCaseComplexity />,
    <MedicationsSelect />,
    <DiagnosticHypothesesSelect />,
    <MedicalProfessionalReferral />,
    <SuicidalIdeation />,
    <DocumentUpload />,
  ],
}

export const OUTCOME_FORM: Form = {
  id: OUTCOME,
  fields: [
    <ComplaintsSelect />,
    <SymptomsSelect />,
    <OtherSymptomsImpactOnWorkLife />,
    <SuicidalIdeation />,
    <PatientConsumption />,
    <MedicationsSelect />,
    <PsychiatristTreatment />,
    <PatientGoal />,
    <PatientCaseComplexity />,
    <PatientNeedsToContinueTreatment />,
    <PatientCaseDescription />,
    <DiagnosticHypothesesSelect />,
    <MedicalProfessionalReferral />,
    <DocumentUpload />,
  ],
}
